<template>
    <!-- Page Header-->
    <Header :title="title" :subtitle="article.subtitle" />
    <!-- Main Content-->
    <main>
        <el-row :gutter=10 justify="center">
            <el-col :md="6" :lg="6" :xl="6" class="hidden-sm-and-down">
                <div class="sliderBar">
                    <el-anchor :container="containerRef" direction="vertical" type="default" :offset="50"
                        @click="handleClick" v-for="(item, index) in aside" :key="index" style="width:100%;">
                        <el-anchor-link :href="'#' + item" :title="item" />
                    </el-anchor>
                </div>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
                <div id="story" v-html="article.story" v-if="article.story" class="info" />
                <div id="capture" class="capture">
                    <h2>保存当前页面</h2>
                    <button class="capture-button" onclick="capture('#story','#captureResult')">故事</button>
                    <br>
                    <img id="captureResult" style="width:100%">
                </div>
            </el-col>
            <el-col :md="6" :lg="6" :xl="6" class="hidden-sm-and-down"></el-col>
        </el-row>
    </main>
</template>
<script setup>
import Header from '../components/Header.vue'
import axios from 'axios'
import { onMounted, ref } from 'vue'
import * as echarts from 'echarts'
import { useRoute } from 'vue-router';


let route = useRoute();
const title = route.params.title[0];
const article = ref([{ subtitle: '', story: '' }]);

const aside = ref([])

const containerRef = ref < HTMLElement | null > (null)

const handleClick = (e) => {
    e.preventDefault()
}

const getData = () => {
    var api = "/article.php?title=" + title;
    axios.get(api).then((res) => {
        article.value = res.data[0];
    }).catch((err) => {
        console.log(err)
    }).then((res) => {
        GetIframeStatus();
        const h = find_tag_h(article.value.story);
        let a = []
        for (let i of h) {
            i.text = i[0].replace(/<h\d[^>]*>/gi, '').replace(/<h\d[^>]*>/gi, '');
            if (i[0].match('h2')) {
                a.push(i.text)
            } else if (i[0].match('h3')) {
                a.push(i.text)
            }
        }
        aside.value = a
        addId('h2')
        addId('h3')
    })
}

onMounted(() => {
    getData()
    var sliderbar = document.querySelector('.sliderBar');
    var bannerTop = document.querySelector('main').offsetTop;
    // 看上图我们发现侧边栏是固定banner部分右边的，因此我们要用两个值相减获取banner顶着浏览器页面最上方的时候，侧边栏距离浏览器最上方的值。
    document.addEventListener('scroll', function () {      // 给【页面】添加一个滚动事件，我们事件的对象时页面的滚动。
        if (window.scrollY >= bannerTop) {    //  浏览器滚动上方被遮盖住的部分大于bannerTop，也就是说banenr上方以及没有东西了，再或者说header部分完全被滚动走了。
            sliderbar.style.position = 'fixed';
            sliderbar.style.top = 200 + 'px';
            // 开始滚动后距屏幕上边缘的固定距离
        } else {
            sliderbar.style.position = 'absolute';  // 如果没有滚动走，那就让侧边栏还随着页面的滚动而滚动
            sliderbar.style.top = '200px';    // 元素起初的位置
        }
    })
})

function find_tag_h(content) {
    let arr = [];
    if (content) {
        let reg = /<h.(?:(?!<\/h.>).|\n)*?<\/h.>/gi;
        const arr = [...content.matchAll(reg)];
        return arr;
    }
    return (arr);
}

function addId(tag) {
    let h = document.querySelectorAll(tag);
    if (h) {
        for (let i of h) {
            i.id = i.innerText
        }
    }
}

function GetIframeStatus() {
    var iframe = document.getElementsByClassName("iframe");
    var iframeWindow = iframe.contentWindow;
    if (iframe) {
        //内容是否加载完
        // var iframeHeight;
        // //获取Iframe的内容实际高度
        // iframeHeight = iframeWindow.document.documentElement.scrollHeight;
        // //设置Iframe的高度
        // iframe.style.height = iframeHeight + 'px';
        for (let i = 0; i < iframe.length; i++) {
            iframe[i].style.height = '550px';
        }
    }
}

</script>
<style scoped>
.sliderBar {
    position: absolute;
    margin-left: 2rem;
    width: 20%;
}

.capture {
    text-align: center;
    margin-top: 3rem;
    margin-bottom: 5rem;
}

iframe {
    width: 100%;
    height: 100%;
}

el-row {
    display: flex;
    flex-wrap: wrap;
}

:deep(p) {
    text-indent: 2em;
    display: block;
}
</style>